<script lang="ts" setup>
import type { Tab } from './Item.vue'
import type { Player, Team } from '~/types'

defineOptions({
  name: 'PlayerNav',
})

interface Props {
  player: Player.Model
  team: Team.Model
}

const props = defineProps<Props>()

const tabs = computed<Tab[]>(() => {
  const params = {
    slug: props.team.slug,
    player: props.player.slug,
  }

  return [
    {
      label: 'Bio',
      path: {
        name: 'teams-slug-player',
        params,
      },
    },
    {
      label: 'Stats',
      path: {
        name: 'teams-slug-player-stats',
        params,
      },
    },
    // {
    //   label: 'Transactions',
    //   path: {
    //     name: 'teams-slug-player-transactions',
    //     params,
    //   },
    // },
    // {
    //   label: 'Video',
    //   path: {
    //     name: 'teams-slug-player-video',
    //     params,
    //   },
    // },
  ]
})
</script>

<template>
  <ul class="player-nav">
    <PlayerNavItem
      v-for="(tab, index) in tabs"
      :key="`player-tab-${index}`"
      v-bind="tab"
      class="player-nav__item"
    />
  </ul>
</template>

<style lang="scss" scoped>
.player-nav {
  @apply flex items-center gap-[30px] overflow-auto pr-[40px];
  @apply md:gap-[40px] md:justify-center md:pr-0;
}
</style>
